const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithTextWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1364.8 280.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M44.76,121.82v121.87h30.16v-121.87h91.3v91.3h-60.73v30.57h60.73l85.1-85.1V37.13h-121.45L44.76,121.82h0ZM221.15,67.29v78.49l-24.37,24.37v-78.49h-78.49l24.37-24.37h78.49Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.49,182.54h30.16v-30.57h-30.16v30.57Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.43,160.7v37.84h-24.58v-116.11h42.85c28.3,0,45.93,13.42,45.93,38.65s-17.63,39.62-45.93,39.62h-18.27ZM345.43,103.13v36.87h18.11c13.91,0,21.67-7.28,21.67-18.76s-7.76-18.11-21.67-18.11h-18.11Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.34,198.54v-116.11h22.64v116.11h-22.64Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.53,155.04c0-25.71,17.95-44.47,42.85-44.47,27.33,0,45.44,22.15,41.4,50.29h-61.29c1.46,14.07,8.25,21.83,19.73,21.83,9.86,0,16.49-4.85,19.08-13.42h22.32c-4.85,19.57-19.89,30.73-40.91,30.73-25.87,0-43.18-17.95-43.18-44.96ZM484.82,146.63h37.19c-.65-11.97-7.44-19.57-18.11-19.57s-17.14,6.79-19.08,19.57Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.25,187.87c-5.66,8.08-14.23,12.29-26.03,12.29-17.95,0-29.92-10.51-29.92-26.68s13.58-25.87,38.81-25.87c4.85,0,9.06.32,14.39.97v-5.18c0-9.7-5.5-15.36-14.88-15.36s-15.52,5.66-16.33,15.36h-20.21c1.29-19.89,15.69-32.83,36.55-32.83,22.64,0,35.9,12.45,35.9,33.64v54.33h-18.27v-10.67ZM591.06,184.63c11.48,0,18.43-6.31,18.43-16.33v-6.15c-5.34-.81-9.06-1.13-12.94-1.13-12.78,0-19.08,4.04-19.08,11.81,0,7.28,5.18,11.8,13.58,11.8Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.59,110.57c10.35,0,19.08,4.53,25.55,12.78v-40.91h22.32v116.11h-20.54v-12.45c-6.79,9.06-16.17,14.07-27.33,14.07-23.29,0-38.32-19.57-38.32-44.79s15.04-44.79,38.32-44.79ZM687.6,180.1c11.16,0,20.37-8.73,20.37-25.06s-9.38-24.58-20.37-24.58-20.21,8.41-20.21,24.9,9.22,24.74,20.21,24.74Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.03,160.7v37.84h-24.58v-116.11h42.85c28.3,0,45.93,13.42,45.93,38.65s-17.63,39.62-45.93,39.62h-18.27ZM777.03,103.13v36.87h18.11c13.91,0,21.67-7.28,21.67-18.76s-7.76-18.11-21.67-18.11h-18.11Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.66,155.04c0-25.71,17.95-44.47,42.85-44.47,27.33,0,45.44,22.15,41.4,50.29h-61.29c1.46,14.07,8.25,21.83,19.73,21.83,9.86,0,16.49-4.85,19.08-13.42h22.32c-4.85,19.57-19.89,30.73-40.91,30.73-25.87,0-43.18-17.95-43.18-44.96ZM871.95,146.63h37.19c-.65-11.97-7.44-19.57-18.11-19.57s-17.14,6.79-19.08,19.57Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.43,198.54h-22.48v-86.35h20.7v16.66c6.31-11,19.73-17.63,33.63-17.63v23.29c-19.08-1.46-31.86,3.07-31.86,22.15v41.88Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.03,198.54v-67.11h-17.46v-19.24h17.46v-4.69c0-17.14,9.22-26.84,27.17-26.84,5.5,0,10.19.97,13.91,2.59v17.79c-2.43-.97-5.66-1.45-8.57-1.45-6.15,0-10.19,2.43-10.19,8.41v4.2h22.48v19.24h-22.48v67.11h-22.32Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.21,155.04c0-25.71,17.95-44.47,42.85-44.47,27.33,0,45.44,22.15,41.4,50.29h-61.29c1.46,14.07,8.25,21.83,19.73,21.83,9.86,0,16.49-4.85,19.08-13.42h22.32c-4.85,19.57-19.89,30.73-40.91,30.73-25.87,0-43.18-17.95-43.18-44.96ZM1098.5,146.63h37.19c-.65-11.97-7.44-19.57-18.11-19.57s-17.14,6.79-19.08,19.57Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.23,155.36c0-25.87,17.79-44.79,42.04-44.79,22.48,0,39.13,15.2,41.88,38.49h-23.61c-1.13-11.48-8.09-18.6-18.27-18.6-11.64,0-19.08,9.54-19.08,24.9s7.28,24.9,19.08,24.9c10.35,0,16.98-6.79,18.27-18.6h23.61c-2.59,23.77-18.76,38.49-41.88,38.49-24.9,0-42.04-18.44-42.04-44.79Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319.23,196.28c-5.5,2.75-10.67,3.88-17.3,3.88-17.79,0-28.95-10.19-28.95-29.59v-39.13h-17.46v-19.24h17.46v-25.55h22.32v25.55h24.74v19.24h-24.74v33.96c0,10.03,4.53,14.07,12.61,14.07,4.2,0,8.08-.97,11.32-2.75v19.57Z",
    style: {
      fill: "#f2f2f2"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithTextWhite);
export default __webpack_public_path__ + "static/media/logo-with-text-white.2c631f8ba63fc024131cc0b04b14ed80.svg";
export { ForwardRef as ReactComponent };